import axios from "axios"
import Loader from "components/Loader/Loader"
import React, { createContext, useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import secureLocalStorage from "react-secure-storage"
import { fetchData } from "utils/Common_api_functions"

const RolesContext = createContext()

export const usePermissionData = () => {
  return useContext(RolesContext)
}

const PrioritiesContext = createContext()

export const usePrioritiesData = () => {
  return useContext(PrioritiesContext)
}

// Design-first shared priorities (TODO: replace with API "priorities" later)
const DUMMY_PRIORITIES = [
  { id: 1, priorityName: "Urgent", unit: "hours", value: 4, createdAt: new Date() },
  { id: 2, priorityName: "High", unit: "days", value: 1, createdAt: new Date() },
  { id: 3, priorityName: "Medium", unit: "days", value: 3, createdAt: new Date() },
  { id: 4, priorityName: "Low", unit: "days", value: 5, createdAt: new Date() },
]

export const AppContext = ({ children }) => {
  const [permissions, setPermissions] = useState([])
  const [loginStatus, setLoginStatus] = useState(false)
  const [loading, setloading] = useState(false)
  const [priorities, setPriorities] = useState(DUMMY_PRIORITIES)

  const location = useLocation()

  const auth_token = secureLocalStorage?.getItem("auth_token")

  useEffect(() => {
    if (permissions.length === 0) {
      getStaffInfo()
    }
  }, [auth_token])

  async function getStaffInfo() {
    const APIdata = await fetchData(setloading, "roles/get-permissions")
    if (APIdata?.success) {
      const parsed = JSON.parse(APIdata?.permissions)

      setPermissions(parsed)
      secureLocalStorage.setItem("permissions", parsed)
    }
  }

  const checkAccess = (mod_id, type) => {
    if (!permissions || !Array.isArray(permissions)) return false

    return permissions.some(permission => {
      return permission.id === mod_id && permission?.[type] == 1
    })
  }
  return (
    <RolesContext.Provider
      value={{
        permissions,
        checkAccess,
        loginStatus,
        setLoginStatus,
        getStaffInfo,
      }}
    >
      <PrioritiesContext.Provider
        value={{
          priorities,
          setPriorities,
        }}
      >
        {loading && <Loader />}
        {children}
      </PrioritiesContext.Provider>
    </RolesContext.Provider>
  )
}
